import { createStyles } from '@mantine/core'

export default createStyles((theme: any) => ({
  mainGrid: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100vw',
    minHeight: '100vh',
    backgroundColor: '#000000',
  },
  innerDiv: {
    maxWidth: '800px',
    marginTop: '75px',
    marginLeft: '20px',
    marginRight: '20px',
    [theme.fn.smallerThan(992)]: {
      marginTop: '50px',
    },
  },
  spanItalic: {
    fontStyle: 'italic',
  },
  spanBolder: {
    fontWeight: 900,
  },
  h1Tag: {
    marginBottom: '0px',
    marginTop: '0px',
    fontSize: '40px',
    [theme.fn.smallerThan(520)]: {
      fontSize: '30px',
    },
    [theme.fn.smallerThan(431)]: {
      fontSize: '25px',
    },
    [theme.fn.smallerThan(331)]: {
      fontSize: '21px',
    },
  },
  h2Tag: {
    marginBottom: '0px',
    marginTop: '0px',
    fontSize: '35px',
    color: '#ff8c00 !important',
    [theme.fn.smallerThan(520)]: {
      fontSize: '25px',
    },
    [theme.fn.smallerThan(431)]: {
      fontSize: '20px',
    },
    [theme.fn.smallerThan(331)]: {
      fontSize: '18px',
    },
  },
  pJoinThousands: {
    marginTop: '0px',
  },
  standardText: {
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  liOlPoint: {
    marginLeft: '40px',
    fontSize: '22px !important',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'normal',
    [theme.fn.smallerThan(992)]: {
      fontSize: '17px',
    },
  },
  spanGood: {
    color: '#8ecd8f',
  },
  ulArticles: {
    listStyle: 'square',
    marginRight: '10px',
    [theme.fn.smallerThan(992)]: {
      paddingLeft: '10px',
      marginLeft: '10px',
      marginRight: '20px',
    },
    [theme.fn.smallerThan(500)]: {
      marginRight: '10px',
      paddingLeft: '5px',
      marginLeft: '5px',
    },
    [theme.fn.smallerThan(400)]: {
      marginRight: '7px',
      paddingLeft: '3px',
      marginLeft: '3px',
    },
    [theme.fn.smallerThan(325)]: {
      marginRight: '3px',
      paddingLeft: '1px',
      marginLeft: '1px',
    },
  },
  liArticle: {
    marginLeft: '40px',
    fontSize: '22px !important',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'normal',
    [theme.fn.smallerThan(992)]: {
      fontSize: '17px',
    },
  },
  articleLink: {
    color: '#b476eeff !important',
    cursor: 'pointer',
    display: 'inline-block',
    '&:hover': {
      opacity: 0.75,
    },
  },
  musicLabel: {
    fontSize: '25px',
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.85,
    },
  },
  musicLabelNotHoverable: {
    fontSize: '25px',
    fontWeight: 'bold',
    cursor: 'default',
  },
  pParagraph: {
    fontFamily: 'Arial, sans-serif',
    color: '#ffffff',
    fontSize: '22px',
  },
  spanEmphasis: {
    fontWeight: 900,
    color: '#ff8c00 !important',
  },
  subSection: {
    color: '#ff8c00 !important',
    fontWeight: 1000,
    fontSize: '28px',
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
  asianTextBlockAlt: {
    whiteSpace: 'nowrap',
    paddingRight: '10px',
  },
  threeDotDivisor: {
    border: 'none',
    height: '1em',
    paddingTop: '30px',
    paddingBottom: '30px',
    background: `radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 0 50%,
              radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 50% 50%,
              radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 100% 50%`,
    backgroundSize: '33.33% 100%',
    backgroundRepeat: 'no-repeat',
    margin: '1em 0;',
  },
  threeDotDivisorBottomOfArticle: {
    border: 'none',
    height: '.7em',
    paddingTop: '70px',
    paddingBottom: '0px !important',
    marginBottom: '0px !important',
    background: `radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 0 50%,
              radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 50% 50%,
              radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 100% 50%`,
    backgroundSize: '33.33% 100%',
    backgroundRepeat: 'no-repeat',
    margin: '1em 0;',
  },
  aHref: {
    color: '#b476eeff',
    '&:hover': {
      opacity: 0.75,
    },
  },
  spanPre: {
    whiteSpace: 'pre',
  },
  dataTableWrapper: {
    minWidth: 'auto',
    maxWidth: '80vw',
    overflowX: 'hidden',
    border: 'none',
    [theme.fn.smallerThan(920)]: {
      minWidth: '85vw',
      maxWidth: '85vw',
      overflowX: 'scroll',
      border: '1px solid rgba(255,255,255,.15)',
    },
  },
  dataTable: {
    borderSpacing: '40px 10px',
    borderCollapse: 'separate',
    minWidth: '500px',
    transform: 'translate(-40px, 0px)',
    [theme.fn.smallerThan(920)]: {
      transform: 'translate(-10px, 0px)',
      borderSpacing: '40px 10px',
    },
    [theme.fn.smallerThan(420)]: {
      transform: 'translate(-25px, 0px)',
    },
    [theme.fn.smallerThan(375)]: {
      transform: 'translate(-30px, 0px)',
    },
  },
  dtCaption: {
    textAlign: 'left',
    visibility: 'hidden',
    clip: 'rect(0,0,0,0)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    border: '0',
    padding: '0',
    margin: '-1px',
    width: '1px',
    height: '1px',
    position: 'absolute',
  },
  dataTableHeader: {
    fontFamily: 'Arial, sans-serif',
    color: '#ff8c00 !important',
    fontWeight: 'bold',
    fontSize: '24px !important',
    textAlign: 'left',
    [theme.fn.smallerThan(920)]: {
      fontSize: '18px !important',
    },
    [theme.fn.smallerThan(500)]: {
      fontSize: '16px !important',
    },
    [theme.fn.smallerThan(420)]: {
      fontSize: '14px !important',
    },
    [theme.fn.smallerThan(375)]: {
      fontSize: '13px !important',
    },
  },
  dataTableField: {
    fontFamily: 'Arial, sans-serif',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '22px !important',
    [theme.fn.smallerThan(920)]: {
      fontSize: '16px !important',
    },
    [theme.fn.smallerThan(500)]: {
      fontSize: '14px !important',
    },
    [theme.fn.smallerThan(420)]: {
      fontSize: '13px !important',
    },
    [theme.fn.smallerThan(375)]: {
      fontSize: '12px !important',
    },
  },
  backLink: {
    display: 'inline-block',
    paddingLeft: '7px',
  },
  link: {
    color: '#b476eeff !important',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.75,
    },
  },
}))
